import { render, staticRenderFns } from "./DFSettings.vue?vue&type=template&id=07bc48d8"
import script from "./DFSettings.vue?vue&type=script&lang=ts"
export * from "./DFSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports